var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRednoteQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 47.25C4.9665 47.25 5.75 46.4665 5.75 45.5C5.75 44.5335 4.9665 43.75 4 43.75C3.0335 43.75 2.25 44.5335 2.25 45.5C2.25 46.4665 3.0335 47.25 4 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 50.75C4.9665 50.75 5.75 49.9665 5.75 49C5.75 48.0335 4.9665 47.25 4 47.25C3.0335 47.25 2.25 48.0335 2.25 49C2.25 49.9665 3.0335 50.75 4 50.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4 57.75C4.9665 57.75 5.75 56.9665 5.75 56C5.75 55.0335 4.9665 54.25 4 54.25C3.0335 54.25 2.25 55.0335 2.25 56C2.25 56.9665 3.0335 57.75 4 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4 61.25C4.9665 61.25 5.75 60.4665 5.75 59.5C5.75 58.5335 4.9665 57.75 4 57.75C3.0335 57.75 2.25 58.5335 2.25 59.5C2.25 60.4665 3.0335 61.25 4 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4 68.25C4.9665 68.25 5.75 67.4665 5.75 66.5C5.75 65.5335 4.9665 64.75 4 64.75C3.0335 64.75 2.25 65.5335 2.25 66.5C2.25 67.4665 3.0335 68.25 4 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.5 36.75C8.4665 36.75 9.25 35.9665 9.25 35C9.25 34.0335 8.4665 33.25 7.5 33.25C6.5335 33.25 5.75 34.0335 5.75 35C5.75 35.9665 6.5335 36.75 7.5 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.5 47.25C8.4665 47.25 9.25 46.4665 9.25 45.5C9.25 44.5335 8.4665 43.75 7.5 43.75C6.5335 43.75 5.75 44.5335 5.75 45.5C5.75 46.4665 6.5335 47.25 7.5 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.5 54.25C8.4665 54.25 9.25 53.4665 9.25 52.5C9.25 51.5335 8.4665 50.75 7.5 50.75C6.5335 50.75 5.75 51.5335 5.75 52.5C5.75 53.4665 6.5335 54.25 7.5 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.5 61.25C8.4665 61.25 9.25 60.4665 9.25 59.5C9.25 58.5335 8.4665 57.75 7.5 57.75C6.5335 57.75 5.75 58.5335 5.75 59.5C5.75 60.4665 6.5335 61.25 7.5 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.5 64.75C8.4665 64.75 9.25 63.9665 9.25 63C9.25 62.0335 8.4665 61.25 7.5 61.25C6.5335 61.25 5.75 62.0335 5.75 63C5.75 63.9665 6.5335 64.75 7.5 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M7.5 68.25C8.4665 68.25 9.25 67.4665 9.25 66.5C9.25 65.5335 8.4665 64.75 7.5 64.75C6.5335 64.75 5.75 65.5335 5.75 66.5C5.75 67.4665 6.5335 68.25 7.5 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M7.5 75.25C8.4665 75.25 9.25 74.4665 9.25 73.5C9.25 72.5335 8.4665 71.75 7.5 71.75C6.5335 71.75 5.75 72.5335 5.75 73.5C5.75 74.4665 6.5335 75.25 7.5 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M11 36.75C11.9665 36.75 12.75 35.9665 12.75 35C12.75 34.0335 11.9665 33.25 11 33.25C10.0335 33.25 9.25 34.0335 9.25 35C9.25 35.9665 10.0335 36.75 11 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M11 40.25C11.9665 40.25 12.75 39.4665 12.75 38.5C12.75 37.5335 11.9665 36.75 11 36.75C10.0335 36.75 9.25 37.5335 9.25 38.5C9.25 39.4665 10.0335 40.25 11 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M11 43.75C11.9665 43.75 12.75 42.9665 12.75 42C12.75 41.0335 11.9665 40.25 11 40.25C10.0335 40.25 9.25 41.0335 9.25 42C9.25 42.9665 10.0335 43.75 11 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11 47.25C11.9665 47.25 12.75 46.4665 12.75 45.5C12.75 44.5335 11.9665 43.75 11 43.75C10.0335 43.75 9.25 44.5335 9.25 45.5C9.25 46.4665 10.0335 47.25 11 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M11 54.25C11.9665 54.25 12.75 53.4665 12.75 52.5C12.75 51.5335 11.9665 50.75 11 50.75C10.0335 50.75 9.25 51.5335 9.25 52.5C9.25 53.4665 10.0335 54.25 11 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M11 57.75C11.9665 57.75 12.75 56.9665 12.75 56C12.75 55.0335 11.9665 54.25 11 54.25C10.0335 54.25 9.25 55.0335 9.25 56C9.25 56.9665 10.0335 57.75 11 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M11 64.75C11.9665 64.75 12.75 63.9665 12.75 63C12.75 62.0335 11.9665 61.25 11 61.25C10.0335 61.25 9.25 62.0335 9.25 63C9.25 63.9665 10.0335 64.75 11 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M11 68.25C11.9665 68.25 12.75 67.4665 12.75 66.5C12.75 65.5335 11.9665 64.75 11 64.75C10.0335 64.75 9.25 65.5335 9.25 66.5C9.25 67.4665 10.0335 68.25 11 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M14.5 33.25C15.4665 33.25 16.25 32.4665 16.25 31.5C16.25 30.5335 15.4665 29.75 14.5 29.75C13.5335 29.75 12.75 30.5335 12.75 31.5C12.75 32.4665 13.5335 33.25 14.5 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M14.5 36.75C15.4665 36.75 16.25 35.9665 16.25 35C16.25 34.0335 15.4665 33.25 14.5 33.25C13.5335 33.25 12.75 34.0335 12.75 35C12.75 35.9665 13.5335 36.75 14.5 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M14.5 40.25C15.4665 40.25 16.25 39.4665 16.25 38.5C16.25 37.5335 15.4665 36.75 14.5 36.75C13.5335 36.75 12.75 37.5335 12.75 38.5C12.75 39.4665 13.5335 40.25 14.5 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M14.5 43.75C15.4665 43.75 16.25 42.9665 16.25 42C16.25 41.0335 15.4665 40.25 14.5 40.25C13.5335 40.25 12.75 41.0335 12.75 42C12.75 42.9665 13.5335 43.75 14.5 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M14.5 54.25C15.4665 54.25 16.25 53.4665 16.25 52.5C16.25 51.5335 15.4665 50.75 14.5 50.75C13.5335 50.75 12.75 51.5335 12.75 52.5C12.75 53.4665 13.5335 54.25 14.5 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M14.5 57.75C15.4665 57.75 16.25 56.9665 16.25 56C16.25 55.0335 15.4665 54.25 14.5 54.25C13.5335 54.25 12.75 55.0335 12.75 56C12.75 56.9665 13.5335 57.75 14.5 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M14.5 64.75C15.4665 64.75 16.25 63.9665 16.25 63C16.25 62.0335 15.4665 61.25 14.5 61.25C13.5335 61.25 12.75 62.0335 12.75 63C12.75 63.9665 13.5335 64.75 14.5 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M14.5 68.25C15.4665 68.25 16.25 67.4665 16.25 66.5C16.25 65.5335 15.4665 64.75 14.5 64.75C13.5335 64.75 12.75 65.5335 12.75 66.5C12.75 67.4665 13.5335 68.25 14.5 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M18 47.25C18.9665 47.25 19.75 46.4665 19.75 45.5C19.75 44.5335 18.9665 43.75 18 43.75C17.0335 43.75 16.25 44.5335 16.25 45.5C16.25 46.4665 17.0335 47.25 18 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M18 54.25C18.9665 54.25 19.75 53.4665 19.75 52.5C19.75 51.5335 18.9665 50.75 18 50.75C17.0335 50.75 16.25 51.5335 16.25 52.5C16.25 53.4665 17.0335 54.25 18 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M18 64.75C18.9665 64.75 19.75 63.9665 19.75 63C19.75 62.0335 18.9665 61.25 18 61.25C17.0335 61.25 16.25 62.0335 16.25 63C16.25 63.9665 17.0335 64.75 18 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M18 68.25C18.9665 68.25 19.75 67.4665 19.75 66.5C19.75 65.5335 18.9665 64.75 18 64.75C17.0335 64.75 16.25 65.5335 16.25 66.5C16.25 67.4665 17.0335 68.25 18 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M18 75.25C18.9665 75.25 19.75 74.4665 19.75 73.5C19.75 72.5335 18.9665 71.75 18 71.75C17.0335 71.75 16.25 72.5335 16.25 73.5C16.25 74.4665 17.0335 75.25 18 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M21.5 33.25C22.4665 33.25 23.25 32.4665 23.25 31.5C23.25 30.5335 22.4665 29.75 21.5 29.75C20.5335 29.75 19.75 30.5335 19.75 31.5C19.75 32.4665 20.5335 33.25 21.5 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M21.5 47.25C22.4665 47.25 23.25 46.4665 23.25 45.5C23.25 44.5335 22.4665 43.75 21.5 43.75C20.5335 43.75 19.75 44.5335 19.75 45.5C19.75 46.4665 20.5335 47.25 21.5 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M21.5 50.75C22.4665 50.75 23.25 49.9665 23.25 49C23.25 48.0335 22.4665 47.25 21.5 47.25C20.5335 47.25 19.75 48.0335 19.75 49C19.75 49.9665 20.5335 50.75 21.5 50.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M21.5 64.75C22.4665 64.75 23.25 63.9665 23.25 63C23.25 62.0335 22.4665 61.25 21.5 61.25C20.5335 61.25 19.75 62.0335 19.75 63C19.75 63.9665 20.5335 64.75 21.5 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M21.5 68.25C22.4665 68.25 23.25 67.4665 23.25 66.5C23.25 65.5335 22.4665 64.75 21.5 64.75C20.5335 64.75 19.75 65.5335 19.75 66.5C19.75 67.4665 20.5335 68.25 21.5 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M25 33.25C25.9665 33.25 26.75 32.4665 26.75 31.5C26.75 30.5335 25.9665 29.75 25 29.75C24.0335 29.75 23.25 30.5335 23.25 31.5C23.25 32.4665 24.0335 33.25 25 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M25 40.25C25.9665 40.25 26.75 39.4665 26.75 38.5C26.75 37.5335 25.9665 36.75 25 36.75C24.0335 36.75 23.25 37.5335 23.25 38.5C23.25 39.4665 24.0335 40.25 25 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M25 47.25C25.9665 47.25 26.75 46.4665 26.75 45.5C26.75 44.5335 25.9665 43.75 25 43.75C24.0335 43.75 23.25 44.5335 23.25 45.5C23.25 46.4665 24.0335 47.25 25 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M25 54.25C25.9665 54.25 26.75 53.4665 26.75 52.5C26.75 51.5335 25.9665 50.75 25 50.75C24.0335 50.75 23.25 51.5335 23.25 52.5C23.25 53.4665 24.0335 54.25 25 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M25 61.25C25.9665 61.25 26.75 60.4665 26.75 59.5C26.75 58.5335 25.9665 57.75 25 57.75C24.0335 57.75 23.25 58.5335 23.25 59.5C23.25 60.4665 24.0335 61.25 25 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M25 68.25C25.9665 68.25 26.75 67.4665 26.75 66.5C26.75 65.5335 25.9665 64.75 25 64.75C24.0335 64.75 23.25 65.5335 23.25 66.5C23.25 67.4665 24.0335 68.25 25 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M25 75.25C25.9665 75.25 26.75 74.4665 26.75 73.5C26.75 72.5335 25.9665 71.75 25 71.75C24.0335 71.75 23.25 72.5335 23.25 73.5C23.25 74.4665 24.0335 75.25 25 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M28.5 33.25C29.4665 33.25 30.25 32.4665 30.25 31.5C30.25 30.5335 29.4665 29.75 28.5 29.75C27.5335 29.75 26.75 30.5335 26.75 31.5C26.75 32.4665 27.5335 33.25 28.5 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M28.5 36.75C29.4665 36.75 30.25 35.9665 30.25 35C30.25 34.0335 29.4665 33.25 28.5 33.25C27.5335 33.25 26.75 34.0335 26.75 35C26.75 35.9665 27.5335 36.75 28.5 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M28.5 43.75C29.4665 43.75 30.25 42.9665 30.25 42C30.25 41.0335 29.4665 40.25 28.5 40.25C27.5335 40.25 26.75 41.0335 26.75 42C26.75 42.9665 27.5335 43.75 28.5 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M28.5 50.75C29.4665 50.75 30.25 49.9665 30.25 49C30.25 48.0335 29.4665 47.25 28.5 47.25C27.5335 47.25 26.75 48.0335 26.75 49C26.75 49.9665 27.5335 50.75 28.5 50.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M28.5 54.25C29.4665 54.25 30.25 53.4665 30.25 52.5C30.25 51.5335 29.4665 50.75 28.5 50.75C27.5335 50.75 26.75 51.5335 26.75 52.5C26.75 53.4665 27.5335 54.25 28.5 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M28.5 61.25C29.4665 61.25 30.25 60.4665 30.25 59.5C30.25 58.5335 29.4665 57.75 28.5 57.75C27.5335 57.75 26.75 58.5335 26.75 59.5C26.75 60.4665 27.5335 61.25 28.5 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M28.5 68.25C29.4665 68.25 30.25 67.4665 30.25 66.5C30.25 65.5335 29.4665 64.75 28.5 64.75C27.5335 64.75 26.75 65.5335 26.75 66.5C26.75 67.4665 27.5335 68.25 28.5 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M28.5 71.75C29.4665 71.75 30.25 70.9665 30.25 70C30.25 69.0335 29.4665 68.25 28.5 68.25C27.5335 68.25 26.75 69.0335 26.75 70C26.75 70.9665 27.5335 71.75 28.5 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M32 8.75C32.9665 8.75 33.75 7.9665 33.75 7C33.75 6.0335 32.9665 5.25 32 5.25C31.0335 5.25 30.25 6.0335 30.25 7C30.25 7.9665 31.0335 8.75 32 8.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M32 12.25C32.9665 12.25 33.75 11.4665 33.75 10.5C33.75 9.5335 32.9665 8.75 32 8.75C31.0335 8.75 30.25 9.5335 30.25 10.5C30.25 11.4665 31.0335 12.25 32 12.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M32 26.25C32.9665 26.25 33.75 25.4665 33.75 24.5C33.75 23.5335 32.9665 22.75 32 22.75C31.0335 22.75 30.25 23.5335 30.25 24.5C30.25 25.4665 31.0335 26.25 32 26.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M32 36.75C32.9665 36.75 33.75 35.9665 33.75 35C33.75 34.0335 32.9665 33.25 32 33.25C31.0335 33.25 30.25 34.0335 30.25 35C30.25 35.9665 31.0335 36.75 32 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M32 71.75C32.9665 71.75 33.75 70.9665 33.75 70C33.75 69.0335 32.9665 68.25 32 68.25C31.0335 68.25 30.25 69.0335 30.25 70C30.25 70.9665 31.0335 71.75 32 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M32 82.25C32.9665 82.25 33.75 81.4665 33.75 80.5C33.75 79.5335 32.9665 78.75 32 78.75C31.0335 78.75 30.25 79.5335 30.25 80.5C30.25 81.4665 31.0335 82.25 32 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M32 85.75C32.9665 85.75 33.75 84.9665 33.75 84C33.75 83.0335 32.9665 82.25 32 82.25C31.0335 82.25 30.25 83.0335 30.25 84C30.25 84.9665 31.0335 85.75 32 85.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M32 92.75C32.9665 92.75 33.75 91.9665 33.75 91C33.75 90.0335 32.9665 89.25 32 89.25C31.0335 89.25 30.25 90.0335 30.25 91C30.25 91.9665 31.0335 92.75 32 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M35.5 5.25C36.4665 5.25 37.25 4.4665 37.25 3.5C37.25 2.5335 36.4665 1.75 35.5 1.75C34.5335 1.75 33.75 2.5335 33.75 3.5C33.75 4.4665 34.5335 5.25 35.5 5.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M35.5 19.25C36.4665 19.25 37.25 18.4665 37.25 17.5C37.25 16.5335 36.4665 15.75 35.5 15.75C34.5335 15.75 33.75 16.5335 33.75 17.5C33.75 18.4665 34.5335 19.25 35.5 19.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M35.5 22.75C36.4665 22.75 37.25 21.9665 37.25 21C37.25 20.0335 36.4665 19.25 35.5 19.25C34.5335 19.25 33.75 20.0335 33.75 21C33.75 21.9665 34.5335 22.75 35.5 22.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M35.5 29.75C36.4665 29.75 37.25 28.9665 37.25 28C37.25 27.0335 36.4665 26.25 35.5 26.25C34.5335 26.25 33.75 27.0335 33.75 28C33.75 28.9665 34.5335 29.75 35.5 29.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M35.5 47.25C36.4665 47.25 37.25 46.4665 37.25 45.5C37.25 44.5335 36.4665 43.75 35.5 43.75C34.5335 43.75 33.75 44.5335 33.75 45.5C33.75 46.4665 34.5335 47.25 35.5 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M35.5 54.25C36.4665 54.25 37.25 53.4665 37.25 52.5C37.25 51.5335 36.4665 50.75 35.5 50.75C34.5335 50.75 33.75 51.5335 33.75 52.5C33.75 53.4665 34.5335 54.25 35.5 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M35.5 57.75C36.4665 57.75 37.25 56.9665 37.25 56C37.25 55.0335 36.4665 54.25 35.5 54.25C34.5335 54.25 33.75 55.0335 33.75 56C33.75 56.9665 34.5335 57.75 35.5 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M35.5 61.25C36.4665 61.25 37.25 60.4665 37.25 59.5C37.25 58.5335 36.4665 57.75 35.5 57.75C34.5335 57.75 33.75 58.5335 33.75 59.5C33.75 60.4665 34.5335 61.25 35.5 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M35.5 64.75C36.4665 64.75 37.25 63.9665 37.25 63C37.25 62.0335 36.4665 61.25 35.5 61.25C34.5335 61.25 33.75 62.0335 33.75 63C33.75 63.9665 34.5335 64.75 35.5 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M35.5 68.25C36.4665 68.25 37.25 67.4665 37.25 66.5C37.25 65.5335 36.4665 64.75 35.5 64.75C34.5335 64.75 33.75 65.5335 33.75 66.5C33.75 67.4665 34.5335 68.25 35.5 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M35.5 71.75C36.4665 71.75 37.25 70.9665 37.25 70C37.25 69.0335 36.4665 68.25 35.5 68.25C34.5335 68.25 33.75 69.0335 33.75 70C33.75 70.9665 34.5335 71.75 35.5 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M35.5 82.25C36.4665 82.25 37.25 81.4665 37.25 80.5C37.25 79.5335 36.4665 78.75 35.5 78.75C34.5335 78.75 33.75 79.5335 33.75 80.5C33.75 81.4665 34.5335 82.25 35.5 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M35.5 85.75C36.4665 85.75 37.25 84.9665 37.25 84C37.25 83.0335 36.4665 82.25 35.5 82.25C34.5335 82.25 33.75 83.0335 33.75 84C33.75 84.9665 34.5335 85.75 35.5 85.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M35.5 99.75C36.4665 99.75 37.25 98.9665 37.25 98C37.25 97.0335 36.4665 96.25 35.5 96.25C34.5335 96.25 33.75 97.0335 33.75 98C33.75 98.9665 34.5335 99.75 35.5 99.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M35.5 103.25C36.4665 103.25 37.25 102.466 37.25 101.5C37.25 100.534 36.4665 99.75 35.5 99.75C34.5335 99.75 33.75 100.534 33.75 101.5C33.75 102.466 34.5335 103.25 35.5 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M39 8.75C39.9665 8.75 40.75 7.9665 40.75 7C40.75 6.0335 39.9665 5.25 39 5.25C38.0335 5.25 37.25 6.0335 37.25 7C37.25 7.9665 38.0335 8.75 39 8.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M39 12.25C39.9665 12.25 40.75 11.4665 40.75 10.5C40.75 9.5335 39.9665 8.75 39 8.75C38.0335 8.75 37.25 9.5335 37.25 10.5C37.25 11.4665 38.0335 12.25 39 12.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M39 26.25C39.9665 26.25 40.75 25.4665 40.75 24.5C40.75 23.5335 39.9665 22.75 39 22.75C38.0335 22.75 37.25 23.5335 37.25 24.5C37.25 25.4665 38.0335 26.25 39 26.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M39 29.75C39.9665 29.75 40.75 28.9665 40.75 28C40.75 27.0335 39.9665 26.25 39 26.25C38.0335 26.25 37.25 27.0335 37.25 28C37.25 28.9665 38.0335 29.75 39 29.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M39 33.25C39.9665 33.25 40.75 32.4665 40.75 31.5C40.75 30.5335 39.9665 29.75 39 29.75C38.0335 29.75 37.25 30.5335 37.25 31.5C37.25 32.4665 38.0335 33.25 39 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M39 40.25C39.9665 40.25 40.75 39.4665 40.75 38.5C40.75 37.5335 39.9665 36.75 39 36.75C38.0335 36.75 37.25 37.5335 37.25 38.5C37.25 39.4665 38.0335 40.25 39 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M39 47.25C39.9665 47.25 40.75 46.4665 40.75 45.5C40.75 44.5335 39.9665 43.75 39 43.75C38.0335 43.75 37.25 44.5335 37.25 45.5C37.25 46.4665 38.0335 47.25 39 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M39 54.25C39.9665 54.25 40.75 53.4665 40.75 52.5C40.75 51.5335 39.9665 50.75 39 50.75C38.0335 50.75 37.25 51.5335 37.25 52.5C37.25 53.4665 38.0335 54.25 39 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M39 57.75C39.9665 57.75 40.75 56.9665 40.75 56C40.75 55.0335 39.9665 54.25 39 54.25C38.0335 54.25 37.25 55.0335 37.25 56C37.25 56.9665 38.0335 57.75 39 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M39 61.25C39.9665 61.25 40.75 60.4665 40.75 59.5C40.75 58.5335 39.9665 57.75 39 57.75C38.0335 57.75 37.25 58.5335 37.25 59.5C37.25 60.4665 38.0335 61.25 39 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M39 64.75C39.9665 64.75 40.75 63.9665 40.75 63C40.75 62.0335 39.9665 61.25 39 61.25C38.0335 61.25 37.25 62.0335 37.25 63C37.25 63.9665 38.0335 64.75 39 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M39 71.75C39.9665 71.75 40.75 70.9665 40.75 70C40.75 69.0335 39.9665 68.25 39 68.25C38.0335 68.25 37.25 69.0335 37.25 70C37.25 70.9665 38.0335 71.75 39 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M39 78.75C39.9665 78.75 40.75 77.9665 40.75 77C40.75 76.0335 39.9665 75.25 39 75.25C38.0335 75.25 37.25 76.0335 37.25 77C37.25 77.9665 38.0335 78.75 39 78.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M39 85.75C39.9665 85.75 40.75 84.9665 40.75 84C40.75 83.0335 39.9665 82.25 39 82.25C38.0335 82.25 37.25 83.0335 37.25 84C37.25 84.9665 38.0335 85.75 39 85.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M39 89.25C39.9665 89.25 40.75 88.4665 40.75 87.5C40.75 86.5335 39.9665 85.75 39 85.75C38.0335 85.75 37.25 86.5335 37.25 87.5C37.25 88.4665 38.0335 89.25 39 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M39 103.25C39.9665 103.25 40.75 102.466 40.75 101.5C40.75 100.534 39.9665 99.75 39 99.75C38.0335 99.75 37.25 100.534 37.25 101.5C37.25 102.466 38.0335 103.25 39 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M42.5 5.25C43.4665 5.25 44.25 4.4665 44.25 3.5C44.25 2.5335 43.4665 1.75 42.5 1.75C41.5335 1.75 40.75 2.5335 40.75 3.5C40.75 4.4665 41.5335 5.25 42.5 5.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M42.5 12.25C43.4665 12.25 44.25 11.4665 44.25 10.5C44.25 9.5335 43.4665 8.75 42.5 8.75C41.5335 8.75 40.75 9.5335 40.75 10.5C40.75 11.4665 41.5335 12.25 42.5 12.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M42.5 15.75C43.4665 15.75 44.25 14.9665 44.25 14C44.25 13.0335 43.4665 12.25 42.5 12.25C41.5335 12.25 40.75 13.0335 40.75 14C40.75 14.9665 41.5335 15.75 42.5 15.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M42.5 22.75C43.4665 22.75 44.25 21.9665 44.25 21C44.25 20.0335 43.4665 19.25 42.5 19.25C41.5335 19.25 40.75 20.0335 40.75 21C40.75 21.9665 41.5335 22.75 42.5 22.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M42.5 29.75C43.4665 29.75 44.25 28.9665 44.25 28C44.25 27.0335 43.4665 26.25 42.5 26.25C41.5335 26.25 40.75 27.0335 40.75 28C40.75 28.9665 41.5335 29.75 42.5 29.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M42.5 40.25C43.4665 40.25 44.25 39.4665 44.25 38.5C44.25 37.5335 43.4665 36.75 42.5 36.75C41.5335 36.75 40.75 37.5335 40.75 38.5C40.75 39.4665 41.5335 40.25 42.5 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M42.5 43.75C43.4665 43.75 44.25 42.9665 44.25 42C44.25 41.0335 43.4665 40.25 42.5 40.25C41.5335 40.25 40.75 41.0335 40.75 42C40.75 42.9665 41.5335 43.75 42.5 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M42.5 47.25C43.4665 47.25 44.25 46.4665 44.25 45.5C44.25 44.5335 43.4665 43.75 42.5 43.75C41.5335 43.75 40.75 44.5335 40.75 45.5C40.75 46.4665 41.5335 47.25 42.5 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M42.5 54.25C43.4665 54.25 44.25 53.4665 44.25 52.5C44.25 51.5335 43.4665 50.75 42.5 50.75C41.5335 50.75 40.75 51.5335 40.75 52.5C40.75 53.4665 41.5335 54.25 42.5 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M42.5 68.25C43.4665 68.25 44.25 67.4665 44.25 66.5C44.25 65.5335 43.4665 64.75 42.5 64.75C41.5335 64.75 40.75 65.5335 40.75 66.5C40.75 67.4665 41.5335 68.25 42.5 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M42.5 71.75C43.4665 71.75 44.25 70.9665 44.25 70C44.25 69.0335 43.4665 68.25 42.5 68.25C41.5335 68.25 40.75 69.0335 40.75 70C40.75 70.9665 41.5335 71.75 42.5 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M42.5 75.25C43.4665 75.25 44.25 74.4665 44.25 73.5C44.25 72.5335 43.4665 71.75 42.5 71.75C41.5335 71.75 40.75 72.5335 40.75 73.5C40.75 74.4665 41.5335 75.25 42.5 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M42.5 82.25C43.4665 82.25 44.25 81.4665 44.25 80.5C44.25 79.5335 43.4665 78.75 42.5 78.75C41.5335 78.75 40.75 79.5335 40.75 80.5C40.75 81.4665 41.5335 82.25 42.5 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M42.5 89.25C43.4665 89.25 44.25 88.4665 44.25 87.5C44.25 86.5335 43.4665 85.75 42.5 85.75C41.5335 85.75 40.75 86.5335 40.75 87.5C40.75 88.4665 41.5335 89.25 42.5 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M42.5 92.75C43.4665 92.75 44.25 91.9665 44.25 91C44.25 90.0335 43.4665 89.25 42.5 89.25C41.5335 89.25 40.75 90.0335 40.75 91C40.75 91.9665 41.5335 92.75 42.5 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M46 5.25C46.9665 5.25 47.75 4.4665 47.75 3.5C47.75 2.5335 46.9665 1.75 46 1.75C45.0335 1.75 44.25 2.5335 44.25 3.5C44.25 4.4665 45.0335 5.25 46 5.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M46 12.25C46.9665 12.25 47.75 11.4665 47.75 10.5C47.75 9.5335 46.9665 8.75 46 8.75C45.0335 8.75 44.25 9.5335 44.25 10.5C44.25 11.4665 45.0335 12.25 46 12.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M46 15.75C46.9665 15.75 47.75 14.9665 47.75 14C47.75 13.0335 46.9665 12.25 46 12.25C45.0335 12.25 44.25 13.0335 44.25 14C44.25 14.9665 45.0335 15.75 46 15.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M46 19.25C46.9665 19.25 47.75 18.4665 47.75 17.5C47.75 16.5335 46.9665 15.75 46 15.75C45.0335 15.75 44.25 16.5335 44.25 17.5C44.25 18.4665 45.0335 19.25 46 19.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M46 26.25C46.9665 26.25 47.75 25.4665 47.75 24.5C47.75 23.5335 46.9665 22.75 46 22.75C45.0335 22.75 44.25 23.5335 44.25 24.5C44.25 25.4665 45.0335 26.25 46 26.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M46 29.75C46.9665 29.75 47.75 28.9665 47.75 28C47.75 27.0335 46.9665 26.25 46 26.25C45.0335 26.25 44.25 27.0335 44.25 28C44.25 28.9665 45.0335 29.75 46 29.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M46 36.75C46.9665 36.75 47.75 35.9665 47.75 35C47.75 34.0335 46.9665 33.25 46 33.25C45.0335 33.25 44.25 34.0335 44.25 35C44.25 35.9665 45.0335 36.75 46 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M46 54.25C46.9665 54.25 47.75 53.4665 47.75 52.5C47.75 51.5335 46.9665 50.75 46 50.75C45.0335 50.75 44.25 51.5335 44.25 52.5C44.25 53.4665 45.0335 54.25 46 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M46 57.75C46.9665 57.75 47.75 56.9665 47.75 56C47.75 55.0335 46.9665 54.25 46 54.25C45.0335 54.25 44.25 55.0335 44.25 56C44.25 56.9665 45.0335 57.75 46 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M46 61.25C46.9665 61.25 47.75 60.4665 47.75 59.5C47.75 58.5335 46.9665 57.75 46 57.75C45.0335 57.75 44.25 58.5335 44.25 59.5C44.25 60.4665 45.0335 61.25 46 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M46 71.75C46.9665 71.75 47.75 70.9665 47.75 70C47.75 69.0335 46.9665 68.25 46 68.25C45.0335 68.25 44.25 69.0335 44.25 70C44.25 70.9665 45.0335 71.75 46 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M46 78.75C46.9665 78.75 47.75 77.9665 47.75 77C47.75 76.0335 46.9665 75.25 46 75.25C45.0335 75.25 44.25 76.0335 44.25 77C44.25 77.9665 45.0335 78.75 46 78.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M46 82.25C46.9665 82.25 47.75 81.4665 47.75 80.5C47.75 79.5335 46.9665 78.75 46 78.75C45.0335 78.75 44.25 79.5335 44.25 80.5C44.25 81.4665 45.0335 82.25 46 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M46 92.75C46.9665 92.75 47.75 91.9665 47.75 91C47.75 90.0335 46.9665 89.25 46 89.25C45.0335 89.25 44.25 90.0335 44.25 91C44.25 91.9665 45.0335 92.75 46 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M46 99.75C46.9665 99.75 47.75 98.9665 47.75 98C47.75 97.0335 46.9665 96.25 46 96.25C45.0335 96.25 44.25 97.0335 44.25 98C44.25 98.9665 45.0335 99.75 46 99.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M49.5 5.25C50.4665 5.25 51.25 4.4665 51.25 3.5C51.25 2.5335 50.4665 1.75 49.5 1.75C48.5335 1.75 47.75 2.5335 47.75 3.5C47.75 4.4665 48.5335 5.25 49.5 5.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M49.5 12.25C50.4665 12.25 51.25 11.4665 51.25 10.5C51.25 9.5335 50.4665 8.75 49.5 8.75C48.5335 8.75 47.75 9.5335 47.75 10.5C47.75 11.4665 48.5335 12.25 49.5 12.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M49.5 19.25C50.4665 19.25 51.25 18.4665 51.25 17.5C51.25 16.5335 50.4665 15.75 49.5 15.75C48.5335 15.75 47.75 16.5335 47.75 17.5C47.75 18.4665 48.5335 19.25 49.5 19.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M49.5 29.75C50.4665 29.75 51.25 28.9665 51.25 28C51.25 27.0335 50.4665 26.25 49.5 26.25C48.5335 26.25 47.75 27.0335 47.75 28C47.75 28.9665 48.5335 29.75 49.5 29.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M49.5 36.75C50.4665 36.75 51.25 35.9665 51.25 35C51.25 34.0335 50.4665 33.25 49.5 33.25C48.5335 33.25 47.75 34.0335 47.75 35C47.75 35.9665 48.5335 36.75 49.5 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M49.5 43.75C50.4665 43.75 51.25 42.9665 51.25 42C51.25 41.0335 50.4665 40.25 49.5 40.25C48.5335 40.25 47.75 41.0335 47.75 42C47.75 42.9665 48.5335 43.75 49.5 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M49.5 50.75C50.4665 50.75 51.25 49.9665 51.25 49C51.25 48.0335 50.4665 47.25 49.5 47.25C48.5335 47.25 47.75 48.0335 47.75 49C47.75 49.9665 48.5335 50.75 49.5 50.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M49.5 54.25C50.4665 54.25 51.25 53.4665 51.25 52.5C51.25 51.5335 50.4665 50.75 49.5 50.75C48.5335 50.75 47.75 51.5335 47.75 52.5C47.75 53.4665 48.5335 54.25 49.5 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M49.5 61.25C50.4665 61.25 51.25 60.4665 51.25 59.5C51.25 58.5335 50.4665 57.75 49.5 57.75C48.5335 57.75 47.75 58.5335 47.75 59.5C47.75 60.4665 48.5335 61.25 49.5 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M49.5 64.75C50.4665 64.75 51.25 63.9665 51.25 63C51.25 62.0335 50.4665 61.25 49.5 61.25C48.5335 61.25 47.75 62.0335 47.75 63C47.75 63.9665 48.5335 64.75 49.5 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M49.5 71.75C50.4665 71.75 51.25 70.9665 51.25 70C51.25 69.0335 50.4665 68.25 49.5 68.25C48.5335 68.25 47.75 69.0335 47.75 70C47.75 70.9665 48.5335 71.75 49.5 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M49.5 75.25C50.4665 75.25 51.25 74.4665 51.25 73.5C51.25 72.5335 50.4665 71.75 49.5 71.75C48.5335 71.75 47.75 72.5335 47.75 73.5C47.75 74.4665 48.5335 75.25 49.5 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M49.5 82.25C50.4665 82.25 51.25 81.4665 51.25 80.5C51.25 79.5335 50.4665 78.75 49.5 78.75C48.5335 78.75 47.75 79.5335 47.75 80.5C47.75 81.4665 48.5335 82.25 49.5 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M49.5 92.75C50.4665 92.75 51.25 91.9665 51.25 91C51.25 90.0335 50.4665 89.25 49.5 89.25C48.5335 89.25 47.75 90.0335 47.75 91C47.75 91.9665 48.5335 92.75 49.5 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M49.5 103.25C50.4665 103.25 51.25 102.466 51.25 101.5C51.25 100.534 50.4665 99.75 49.5 99.75C48.5335 99.75 47.75 100.534 47.75 101.5C47.75 102.466 48.5335 103.25 49.5 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M53 5.25C53.9665 5.25 54.75 4.4665 54.75 3.5C54.75 2.5335 53.9665 1.75 53 1.75C52.0335 1.75 51.25 2.5335 51.25 3.5C51.25 4.4665 52.0335 5.25 53 5.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M53 8.75C53.9665 8.75 54.75 7.9665 54.75 7C54.75 6.0335 53.9665 5.25 53 5.25C52.0335 5.25 51.25 6.0335 51.25 7C51.25 7.9665 52.0335 8.75 53 8.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M53 19.25C53.9665 19.25 54.75 18.4665 54.75 17.5C54.75 16.5335 53.9665 15.75 53 15.75C52.0335 15.75 51.25 16.5335 51.25 17.5C51.25 18.4665 52.0335 19.25 53 19.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M53 22.75C53.9665 22.75 54.75 21.9665 54.75 21C54.75 20.0335 53.9665 19.25 53 19.25C52.0335 19.25 51.25 20.0335 51.25 21C51.25 21.9665 52.0335 22.75 53 22.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M53 26.25C53.9665 26.25 54.75 25.4665 54.75 24.5C54.75 23.5335 53.9665 22.75 53 22.75C52.0335 22.75 51.25 23.5335 51.25 24.5C51.25 25.4665 52.0335 26.25 53 26.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M53 36.75C53.9665 36.75 54.75 35.9665 54.75 35C54.75 34.0335 53.9665 33.25 53 33.25C52.0335 33.25 51.25 34.0335 51.25 35C51.25 35.9665 52.0335 36.75 53 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M53 43.75C53.9665 43.75 54.75 42.9665 54.75 42C54.75 41.0335 53.9665 40.25 53 40.25C52.0335 40.25 51.25 41.0335 51.25 42C51.25 42.9665 52.0335 43.75 53 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M53 47.25C53.9665 47.25 54.75 46.4665 54.75 45.5C54.75 44.5335 53.9665 43.75 53 43.75C52.0335 43.75 51.25 44.5335 51.25 45.5C51.25 46.4665 52.0335 47.25 53 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M53 50.75C53.9665 50.75 54.75 49.9665 54.75 49C54.75 48.0335 53.9665 47.25 53 47.25C52.0335 47.25 51.25 48.0335 51.25 49C51.25 49.9665 52.0335 50.75 53 50.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M53 57.75C53.9665 57.75 54.75 56.9665 54.75 56C54.75 55.0335 53.9665 54.25 53 54.25C52.0335 54.25 51.25 55.0335 51.25 56C51.25 56.9665 52.0335 57.75 53 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M53 61.25C53.9665 61.25 54.75 60.4665 54.75 59.5C54.75 58.5335 53.9665 57.75 53 57.75C52.0335 57.75 51.25 58.5335 51.25 59.5C51.25 60.4665 52.0335 61.25 53 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M53 64.75C53.9665 64.75 54.75 63.9665 54.75 63C54.75 62.0335 53.9665 61.25 53 61.25C52.0335 61.25 51.25 62.0335 51.25 63C51.25 63.9665 52.0335 64.75 53 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M53 68.25C53.9665 68.25 54.75 67.4665 54.75 66.5C54.75 65.5335 53.9665 64.75 53 64.75C52.0335 64.75 51.25 65.5335 51.25 66.5C51.25 67.4665 52.0335 68.25 53 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M53 71.75C53.9665 71.75 54.75 70.9665 54.75 70C54.75 69.0335 53.9665 68.25 53 68.25C52.0335 68.25 51.25 69.0335 51.25 70C51.25 70.9665 52.0335 71.75 53 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M53 82.25C53.9665 82.25 54.75 81.4665 54.75 80.5C54.75 79.5335 53.9665 78.75 53 78.75C52.0335 78.75 51.25 79.5335 51.25 80.5C51.25 81.4665 52.0335 82.25 53 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M53 92.75C53.9665 92.75 54.75 91.9665 54.75 91C54.75 90.0335 53.9665 89.25 53 89.25C52.0335 89.25 51.25 90.0335 51.25 91C51.25 91.9665 52.0335 92.75 53 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M53 96.25C53.9665 96.25 54.75 95.4665 54.75 94.5C54.75 93.5335 53.9665 92.75 53 92.75C52.0335 92.75 51.25 93.5335 51.25 94.5C51.25 95.4665 52.0335 96.25 53 96.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M53 103.25C53.9665 103.25 54.75 102.466 54.75 101.5C54.75 100.534 53.9665 99.75 53 99.75C52.0335 99.75 51.25 100.534 51.25 101.5C51.25 102.466 52.0335 103.25 53 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M56.5 5.25C57.4665 5.25 58.25 4.4665 58.25 3.5C58.25 2.5335 57.4665 1.75 56.5 1.75C55.5335 1.75 54.75 2.5335 54.75 3.5C54.75 4.4665 55.5335 5.25 56.5 5.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M56.5 15.75C57.4665 15.75 58.25 14.9665 58.25 14C58.25 13.0335 57.4665 12.25 56.5 12.25C55.5335 12.25 54.75 13.0335 54.75 14C54.75 14.9665 55.5335 15.75 56.5 15.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M56.5 29.75C57.4665 29.75 58.25 28.9665 58.25 28C58.25 27.0335 57.4665 26.25 56.5 26.25C55.5335 26.25 54.75 27.0335 54.75 28C54.75 28.9665 55.5335 29.75 56.5 29.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M56.5 33.25C57.4665 33.25 58.25 32.4665 58.25 31.5C58.25 30.5335 57.4665 29.75 56.5 29.75C55.5335 29.75 54.75 30.5335 54.75 31.5C54.75 32.4665 55.5335 33.25 56.5 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M56.5 36.75C57.4665 36.75 58.25 35.9665 58.25 35C58.25 34.0335 57.4665 33.25 56.5 33.25C55.5335 33.25 54.75 34.0335 54.75 35C54.75 35.9665 55.5335 36.75 56.5 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M56.5 43.75C57.4665 43.75 58.25 42.9665 58.25 42C58.25 41.0335 57.4665 40.25 56.5 40.25C55.5335 40.25 54.75 41.0335 54.75 42C54.75 42.9665 55.5335 43.75 56.5 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M56.5 50.75C57.4665 50.75 58.25 49.9665 58.25 49C58.25 48.0335 57.4665 47.25 56.5 47.25C55.5335 47.25 54.75 48.0335 54.75 49C54.75 49.9665 55.5335 50.75 56.5 50.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M56.5 57.75C57.4665 57.75 58.25 56.9665 58.25 56C58.25 55.0335 57.4665 54.25 56.5 54.25C55.5335 54.25 54.75 55.0335 54.75 56C54.75 56.9665 55.5335 57.75 56.5 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M56.5 78.75C57.4665 78.75 58.25 77.9665 58.25 77C58.25 76.0335 57.4665 75.25 56.5 75.25C55.5335 75.25 54.75 76.0335 54.75 77C54.75 77.9665 55.5335 78.75 56.5 78.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M56.5 92.75C57.4665 92.75 58.25 91.9665 58.25 91C58.25 90.0335 57.4665 89.25 56.5 89.25C55.5335 89.25 54.75 90.0335 54.75 91C54.75 91.9665 55.5335 92.75 56.5 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M56.5 103.25C57.4665 103.25 58.25 102.466 58.25 101.5C58.25 100.534 57.4665 99.75 56.5 99.75C55.5335 99.75 54.75 100.534 54.75 101.5C54.75 102.466 55.5335 103.25 56.5 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M60 5.25C60.9665 5.25 61.75 4.4665 61.75 3.5C61.75 2.5335 60.9665 1.75 60 1.75C59.0335 1.75 58.25 2.5335 58.25 3.5C58.25 4.4665 59.0335 5.25 60 5.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M60 15.75C60.9665 15.75 61.75 14.9665 61.75 14C61.75 13.0335 60.9665 12.25 60 12.25C59.0335 12.25 58.25 13.0335 58.25 14C58.25 14.9665 59.0335 15.75 60 15.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M60 19.25C60.9665 19.25 61.75 18.4665 61.75 17.5C61.75 16.5335 60.9665 15.75 60 15.75C59.0335 15.75 58.25 16.5335 58.25 17.5C58.25 18.4665 59.0335 19.25 60 19.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M60 26.25C60.9665 26.25 61.75 25.4665 61.75 24.5C61.75 23.5335 60.9665 22.75 60 22.75C59.0335 22.75 58.25 23.5335 58.25 24.5C58.25 25.4665 59.0335 26.25 60 26.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M60 33.25C60.9665 33.25 61.75 32.4665 61.75 31.5C61.75 30.5335 60.9665 29.75 60 29.75C59.0335 29.75 58.25 30.5335 58.25 31.5C58.25 32.4665 59.0335 33.25 60 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M60 36.75C60.9665 36.75 61.75 35.9665 61.75 35C61.75 34.0335 60.9665 33.25 60 33.25C59.0335 33.25 58.25 34.0335 58.25 35C58.25 35.9665 59.0335 36.75 60 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M60 40.25C60.9665 40.25 61.75 39.4665 61.75 38.5C61.75 37.5335 60.9665 36.75 60 36.75C59.0335 36.75 58.25 37.5335 58.25 38.5C58.25 39.4665 59.0335 40.25 60 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M60 43.75C60.9665 43.75 61.75 42.9665 61.75 42C61.75 41.0335 60.9665 40.25 60 40.25C59.0335 40.25 58.25 41.0335 58.25 42C58.25 42.9665 59.0335 43.75 60 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M60 50.75C60.9665 50.75 61.75 49.9665 61.75 49C61.75 48.0335 60.9665 47.25 60 47.25C59.0335 47.25 58.25 48.0335 58.25 49C58.25 49.9665 59.0335 50.75 60 50.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M60 54.25C60.9665 54.25 61.75 53.4665 61.75 52.5C61.75 51.5335 60.9665 50.75 60 50.75C59.0335 50.75 58.25 51.5335 58.25 52.5C58.25 53.4665 59.0335 54.25 60 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M60 61.25C60.9665 61.25 61.75 60.4665 61.75 59.5C61.75 58.5335 60.9665 57.75 60 57.75C59.0335 57.75 58.25 58.5335 58.25 59.5C58.25 60.4665 59.0335 61.25 60 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M60 64.75C60.9665 64.75 61.75 63.9665 61.75 63C61.75 62.0335 60.9665 61.25 60 61.25C59.0335 61.25 58.25 62.0335 58.25 63C58.25 63.9665 59.0335 64.75 60 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M60 68.25C60.9665 68.25 61.75 67.4665 61.75 66.5C61.75 65.5335 60.9665 64.75 60 64.75C59.0335 64.75 58.25 65.5335 58.25 66.5C58.25 67.4665 59.0335 68.25 60 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M60 71.75C60.9665 71.75 61.75 70.9665 61.75 70C61.75 69.0335 60.9665 68.25 60 68.25C59.0335 68.25 58.25 69.0335 58.25 70C58.25 70.9665 59.0335 71.75 60 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M60 75.25C60.9665 75.25 61.75 74.4665 61.75 73.5C61.75 72.5335 60.9665 71.75 60 71.75C59.0335 71.75 58.25 72.5335 58.25 73.5C58.25 74.4665 59.0335 75.25 60 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M60 78.75C60.9665 78.75 61.75 77.9665 61.75 77C61.75 76.0335 60.9665 75.25 60 75.25C59.0335 75.25 58.25 76.0335 58.25 77C58.25 77.9665 59.0335 78.75 60 78.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M60 82.25C60.9665 82.25 61.75 81.4665 61.75 80.5C61.75 79.5335 60.9665 78.75 60 78.75C59.0335 78.75 58.25 79.5335 58.25 80.5C58.25 81.4665 59.0335 82.25 60 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M60 85.75C60.9665 85.75 61.75 84.9665 61.75 84C61.75 83.0335 60.9665 82.25 60 82.25C59.0335 82.25 58.25 83.0335 58.25 84C58.25 84.9665 59.0335 85.75 60 85.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M60 89.25C60.9665 89.25 61.75 88.4665 61.75 87.5C61.75 86.5335 60.9665 85.75 60 85.75C59.0335 85.75 58.25 86.5335 58.25 87.5C58.25 88.4665 59.0335 89.25 60 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M63.5 8.75C64.4665 8.75 65.25 7.9665 65.25 7C65.25 6.0335 64.4665 5.25 63.5 5.25C62.5335 5.25 61.75 6.0335 61.75 7C61.75 7.9665 62.5335 8.75 63.5 8.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M63.5 12.25C64.4665 12.25 65.25 11.4665 65.25 10.5C65.25 9.5335 64.4665 8.75 63.5 8.75C62.5335 8.75 61.75 9.5335 61.75 10.5C61.75 11.4665 62.5335 12.25 63.5 12.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M63.5 22.75C64.4665 22.75 65.25 21.9665 65.25 21C65.25 20.0335 64.4665 19.25 63.5 19.25C62.5335 19.25 61.75 20.0335 61.75 21C61.75 21.9665 62.5335 22.75 63.5 22.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M63.5 29.75C64.4665 29.75 65.25 28.9665 65.25 28C65.25 27.0335 64.4665 26.25 63.5 26.25C62.5335 26.25 61.75 27.0335 61.75 28C61.75 28.9665 62.5335 29.75 63.5 29.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M63.5 36.75C64.4665 36.75 65.25 35.9665 65.25 35C65.25 34.0335 64.4665 33.25 63.5 33.25C62.5335 33.25 61.75 34.0335 61.75 35C61.75 35.9665 62.5335 36.75 63.5 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M63.5 54.25C64.4665 54.25 65.25 53.4665 65.25 52.5C65.25 51.5335 64.4665 50.75 63.5 50.75C62.5335 50.75 61.75 51.5335 61.75 52.5C61.75 53.4665 62.5335 54.25 63.5 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M63.5 61.25C64.4665 61.25 65.25 60.4665 65.25 59.5C65.25 58.5335 64.4665 57.75 63.5 57.75C62.5335 57.75 61.75 58.5335 61.75 59.5C61.75 60.4665 62.5335 61.25 63.5 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M63.5 71.75C64.4665 71.75 65.25 70.9665 65.25 70C65.25 69.0335 64.4665 68.25 63.5 68.25C62.5335 68.25 61.75 69.0335 61.75 70C61.75 70.9665 62.5335 71.75 63.5 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M63.5 75.25C64.4665 75.25 65.25 74.4665 65.25 73.5C65.25 72.5335 64.4665 71.75 63.5 71.75C62.5335 71.75 61.75 72.5335 61.75 73.5C61.75 74.4665 62.5335 75.25 63.5 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M63.5 78.75C64.4665 78.75 65.25 77.9665 65.25 77C65.25 76.0335 64.4665 75.25 63.5 75.25C62.5335 75.25 61.75 76.0335 61.75 77C61.75 77.9665 62.5335 78.75 63.5 78.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M63.5 82.25C64.4665 82.25 65.25 81.4665 65.25 80.5C65.25 79.5335 64.4665 78.75 63.5 78.75C62.5335 78.75 61.75 79.5335 61.75 80.5C61.75 81.4665 62.5335 82.25 63.5 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M63.5 85.75C64.4665 85.75 65.25 84.9665 65.25 84C65.25 83.0335 64.4665 82.25 63.5 82.25C62.5335 82.25 61.75 83.0335 61.75 84C61.75 84.9665 62.5335 85.75 63.5 85.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M63.5 92.75C64.4665 92.75 65.25 91.9665 65.25 91C65.25 90.0335 64.4665 89.25 63.5 89.25C62.5335 89.25 61.75 90.0335 61.75 91C61.75 91.9665 62.5335 92.75 63.5 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M63.5 96.25C64.4665 96.25 65.25 95.4665 65.25 94.5C65.25 93.5335 64.4665 92.75 63.5 92.75C62.5335 92.75 61.75 93.5335 61.75 94.5C61.75 95.4665 62.5335 96.25 63.5 96.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M63.5 103.25C64.4665 103.25 65.25 102.466 65.25 101.5C65.25 100.534 64.4665 99.75 63.5 99.75C62.5335 99.75 61.75 100.534 61.75 101.5C61.75 102.466 62.5335 103.25 63.5 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M67 5.25C67.9665 5.25 68.75 4.4665 68.75 3.5C68.75 2.5335 67.9665 1.75 67 1.75C66.0335 1.75 65.25 2.5335 65.25 3.5C65.25 4.4665 66.0335 5.25 67 5.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M67 8.75C67.9665 8.75 68.75 7.9665 68.75 7C68.75 6.0335 67.9665 5.25 67 5.25C66.0335 5.25 65.25 6.0335 65.25 7C65.25 7.9665 66.0335 8.75 67 8.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M67 12.25C67.9665 12.25 68.75 11.4665 68.75 10.5C68.75 9.5335 67.9665 8.75 67 8.75C66.0335 8.75 65.25 9.5335 65.25 10.5C65.25 11.4665 66.0335 12.25 67 12.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M67 15.75C67.9665 15.75 68.75 14.9665 68.75 14C68.75 13.0335 67.9665 12.25 67 12.25C66.0335 12.25 65.25 13.0335 65.25 14C65.25 14.9665 66.0335 15.75 67 15.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M67 22.75C67.9665 22.75 68.75 21.9665 68.75 21C68.75 20.0335 67.9665 19.25 67 19.25C66.0335 19.25 65.25 20.0335 65.25 21C65.25 21.9665 66.0335 22.75 67 22.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M67 26.25C67.9665 26.25 68.75 25.4665 68.75 24.5C68.75 23.5335 67.9665 22.75 67 22.75C66.0335 22.75 65.25 23.5335 65.25 24.5C65.25 25.4665 66.0335 26.25 67 26.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M67 29.75C67.9665 29.75 68.75 28.9665 68.75 28C68.75 27.0335 67.9665 26.25 67 26.25C66.0335 26.25 65.25 27.0335 65.25 28C65.25 28.9665 66.0335 29.75 67 29.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M67 47.25C67.9665 47.25 68.75 46.4665 68.75 45.5C68.75 44.5335 67.9665 43.75 67 43.75C66.0335 43.75 65.25 44.5335 65.25 45.5C65.25 46.4665 66.0335 47.25 67 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M67 54.25C67.9665 54.25 68.75 53.4665 68.75 52.5C68.75 51.5335 67.9665 50.75 67 50.75C66.0335 50.75 65.25 51.5335 65.25 52.5C65.25 53.4665 66.0335 54.25 67 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M67 61.25C67.9665 61.25 68.75 60.4665 68.75 59.5C68.75 58.5335 67.9665 57.75 67 57.75C66.0335 57.75 65.25 58.5335 65.25 59.5C65.25 60.4665 66.0335 61.25 67 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M67 64.75C67.9665 64.75 68.75 63.9665 68.75 63C68.75 62.0335 67.9665 61.25 67 61.25C66.0335 61.25 65.25 62.0335 65.25 63C65.25 63.9665 66.0335 64.75 67 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M67 71.75C67.9665 71.75 68.75 70.9665 68.75 70C68.75 69.0335 67.9665 68.25 67 68.25C66.0335 68.25 65.25 69.0335 65.25 70C65.25 70.9665 66.0335 71.75 67 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M67 103.25C67.9665 103.25 68.75 102.466 68.75 101.5C68.75 100.534 67.9665 99.75 67 99.75C66.0335 99.75 65.25 100.534 65.25 101.5C65.25 102.466 66.0335 103.25 67 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M70.5 12.25C71.4665 12.25 72.25 11.4665 72.25 10.5C72.25 9.5335 71.4665 8.75 70.5 8.75C69.5335 8.75 68.75 9.5335 68.75 10.5C68.75 11.4665 69.5335 12.25 70.5 12.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M70.5 15.75C71.4665 15.75 72.25 14.9665 72.25 14C72.25 13.0335 71.4665 12.25 70.5 12.25C69.5335 12.25 68.75 13.0335 68.75 14C68.75 14.9665 69.5335 15.75 70.5 15.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M70.5 19.25C71.4665 19.25 72.25 18.4665 72.25 17.5C72.25 16.5335 71.4665 15.75 70.5 15.75C69.5335 15.75 68.75 16.5335 68.75 17.5C68.75 18.4665 69.5335 19.25 70.5 19.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M70.5 22.75C71.4665 22.75 72.25 21.9665 72.25 21C72.25 20.0335 71.4665 19.25 70.5 19.25C69.5335 19.25 68.75 20.0335 68.75 21C68.75 21.9665 69.5335 22.75 70.5 22.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M70.5 29.75C71.4665 29.75 72.25 28.9665 72.25 28C72.25 27.0335 71.4665 26.25 70.5 26.25C69.5335 26.25 68.75 27.0335 68.75 28C68.75 28.9665 69.5335 29.75 70.5 29.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M70.5 33.25C71.4665 33.25 72.25 32.4665 72.25 31.5C72.25 30.5335 71.4665 29.75 70.5 29.75C69.5335 29.75 68.75 30.5335 68.75 31.5C68.75 32.4665 69.5335 33.25 70.5 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M70.5 40.25C71.4665 40.25 72.25 39.4665 72.25 38.5C72.25 37.5335 71.4665 36.75 70.5 36.75C69.5335 36.75 68.75 37.5335 68.75 38.5C68.75 39.4665 69.5335 40.25 70.5 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M70.5 43.75C71.4665 43.75 72.25 42.9665 72.25 42C72.25 41.0335 71.4665 40.25 70.5 40.25C69.5335 40.25 68.75 41.0335 68.75 42C68.75 42.9665 69.5335 43.75 70.5 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M70.5 50.75C71.4665 50.75 72.25 49.9665 72.25 49C72.25 48.0335 71.4665 47.25 70.5 47.25C69.5335 47.25 68.75 48.0335 68.75 49C68.75 49.9665 69.5335 50.75 70.5 50.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M70.5 54.25C71.4665 54.25 72.25 53.4665 72.25 52.5C72.25 51.5335 71.4665 50.75 70.5 50.75C69.5335 50.75 68.75 51.5335 68.75 52.5C68.75 53.4665 69.5335 54.25 70.5 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M70.5 57.75C71.4665 57.75 72.25 56.9665 72.25 56C72.25 55.0335 71.4665 54.25 70.5 54.25C69.5335 54.25 68.75 55.0335 68.75 56C68.75 56.9665 69.5335 57.75 70.5 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M70.5 61.25C71.4665 61.25 72.25 60.4665 72.25 59.5C72.25 58.5335 71.4665 57.75 70.5 57.75C69.5335 57.75 68.75 58.5335 68.75 59.5C68.75 60.4665 69.5335 61.25 70.5 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M70.5 68.25C71.4665 68.25 72.25 67.4665 72.25 66.5C72.25 65.5335 71.4665 64.75 70.5 64.75C69.5335 64.75 68.75 65.5335 68.75 66.5C68.75 67.4665 69.5335 68.25 70.5 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M70.5 71.75C71.4665 71.75 72.25 70.9665 72.25 70C72.25 69.0335 71.4665 68.25 70.5 68.25C69.5335 68.25 68.75 69.0335 68.75 70C68.75 70.9665 69.5335 71.75 70.5 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M70.5 75.25C71.4665 75.25 72.25 74.4665 72.25 73.5C72.25 72.5335 71.4665 71.75 70.5 71.75C69.5335 71.75 68.75 72.5335 68.75 73.5C68.75 74.4665 69.5335 75.25 70.5 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M70.5 78.75C71.4665 78.75 72.25 77.9665 72.25 77C72.25 76.0335 71.4665 75.25 70.5 75.25C69.5335 75.25 68.75 76.0335 68.75 77C68.75 77.9665 69.5335 78.75 70.5 78.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M70.5 82.25C71.4665 82.25 72.25 81.4665 72.25 80.5C72.25 79.5335 71.4665 78.75 70.5 78.75C69.5335 78.75 68.75 79.5335 68.75 80.5C68.75 81.4665 69.5335 82.25 70.5 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M70.5 85.75C71.4665 85.75 72.25 84.9665 72.25 84C72.25 83.0335 71.4665 82.25 70.5 82.25C69.5335 82.25 68.75 83.0335 68.75 84C68.75 84.9665 69.5335 85.75 70.5 85.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M70.5 89.25C71.4665 89.25 72.25 88.4665 72.25 87.5C72.25 86.5335 71.4665 85.75 70.5 85.75C69.5335 85.75 68.75 86.5335 68.75 87.5C68.75 88.4665 69.5335 89.25 70.5 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M70.5 92.75C71.4665 92.75 72.25 91.9665 72.25 91C72.25 90.0335 71.4665 89.25 70.5 89.25C69.5335 89.25 68.75 90.0335 68.75 91C68.75 91.9665 69.5335 92.75 70.5 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M70.5 99.75C71.4665 99.75 72.25 98.9665 72.25 98C72.25 97.0335 71.4665 96.25 70.5 96.25C69.5335 96.25 68.75 97.0335 68.75 98C68.75 98.9665 69.5335 99.75 70.5 99.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M74 5.25C74.9665 5.25 75.75 4.4665 75.75 3.5C75.75 2.5335 74.9665 1.75 74 1.75C73.0335 1.75 72.25 2.5335 72.25 3.5C72.25 4.4665 73.0335 5.25 74 5.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M74 8.75C74.9665 8.75 75.75 7.9665 75.75 7C75.75 6.0335 74.9665 5.25 74 5.25C73.0335 5.25 72.25 6.0335 72.25 7C72.25 7.9665 73.0335 8.75 74 8.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M74 19.25C74.9665 19.25 75.75 18.4665 75.75 17.5C75.75 16.5335 74.9665 15.75 74 15.75C73.0335 15.75 72.25 16.5335 72.25 17.5C72.25 18.4665 73.0335 19.25 74 19.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M74 26.25C74.9665 26.25 75.75 25.4665 75.75 24.5C75.75 23.5335 74.9665 22.75 74 22.75C73.0335 22.75 72.25 23.5335 72.25 24.5C72.25 25.4665 73.0335 26.25 74 26.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M74 33.25C74.9665 33.25 75.75 32.4665 75.75 31.5C75.75 30.5335 74.9665 29.75 74 29.75C73.0335 29.75 72.25 30.5335 72.25 31.5C72.25 32.4665 73.0335 33.25 74 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M74 47.25C74.9665 47.25 75.75 46.4665 75.75 45.5C75.75 44.5335 74.9665 43.75 74 43.75C73.0335 43.75 72.25 44.5335 72.25 45.5C72.25 46.4665 73.0335 47.25 74 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M74 50.75C74.9665 50.75 75.75 49.9665 75.75 49C75.75 48.0335 74.9665 47.25 74 47.25C73.0335 47.25 72.25 48.0335 72.25 49C72.25 49.9665 73.0335 50.75 74 50.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M74 54.25C74.9665 54.25 75.75 53.4665 75.75 52.5C75.75 51.5335 74.9665 50.75 74 50.75C73.0335 50.75 72.25 51.5335 72.25 52.5C72.25 53.4665 73.0335 54.25 74 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M74 68.25C74.9665 68.25 75.75 67.4665 75.75 66.5C75.75 65.5335 74.9665 64.75 74 64.75C73.0335 64.75 72.25 65.5335 72.25 66.5C72.25 67.4665 73.0335 68.25 74 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M74 71.75C74.9665 71.75 75.75 70.9665 75.75 70C75.75 69.0335 74.9665 68.25 74 68.25C73.0335 68.25 72.25 69.0335 72.25 70C72.25 70.9665 73.0335 71.75 74 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M74 75.25C74.9665 75.25 75.75 74.4665 75.75 73.5C75.75 72.5335 74.9665 71.75 74 71.75C73.0335 71.75 72.25 72.5335 72.25 73.5C72.25 74.4665 73.0335 75.25 74 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M74 78.75C74.9665 78.75 75.75 77.9665 75.75 77C75.75 76.0335 74.9665 75.25 74 75.25C73.0335 75.25 72.25 76.0335 72.25 77C72.25 77.9665 73.0335 78.75 74 78.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M74 82.25C74.9665 82.25 75.75 81.4665 75.75 80.5C75.75 79.5335 74.9665 78.75 74 78.75C73.0335 78.75 72.25 79.5335 72.25 80.5C72.25 81.4665 73.0335 82.25 74 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M74 85.75C74.9665 85.75 75.75 84.9665 75.75 84C75.75 83.0335 74.9665 82.25 74 82.25C73.0335 82.25 72.25 83.0335 72.25 84C72.25 84.9665 73.0335 85.75 74 85.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M74 89.25C74.9665 89.25 75.75 88.4665 75.75 87.5C75.75 86.5335 74.9665 85.75 74 85.75C73.0335 85.75 72.25 86.5335 72.25 87.5C72.25 88.4665 73.0335 89.25 74 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M74 92.75C74.9665 92.75 75.75 91.9665 75.75 91C75.75 90.0335 74.9665 89.25 74 89.25C73.0335 89.25 72.25 90.0335 72.25 91C72.25 91.9665 73.0335 92.75 74 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M77.5 33.25C78.4665 33.25 79.25 32.4665 79.25 31.5C79.25 30.5335 78.4665 29.75 77.5 29.75C76.5335 29.75 75.75 30.5335 75.75 31.5C75.75 32.4665 76.5335 33.25 77.5 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M77.5 36.75C78.4665 36.75 79.25 35.9665 79.25 35C79.25 34.0335 78.4665 33.25 77.5 33.25C76.5335 33.25 75.75 34.0335 75.75 35C75.75 35.9665 76.5335 36.75 77.5 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M77.5 40.25C78.4665 40.25 79.25 39.4665 79.25 38.5C79.25 37.5335 78.4665 36.75 77.5 36.75C76.5335 36.75 75.75 37.5335 75.75 38.5C75.75 39.4665 76.5335 40.25 77.5 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M77.5 47.25C78.4665 47.25 79.25 46.4665 79.25 45.5C79.25 44.5335 78.4665 43.75 77.5 43.75C76.5335 43.75 75.75 44.5335 75.75 45.5C75.75 46.4665 76.5335 47.25 77.5 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M77.5 54.25C78.4665 54.25 79.25 53.4665 79.25 52.5C79.25 51.5335 78.4665 50.75 77.5 50.75C76.5335 50.75 75.75 51.5335 75.75 52.5C75.75 53.4665 76.5335 54.25 77.5 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M77.5 57.75C78.4665 57.75 79.25 56.9665 79.25 56C79.25 55.0335 78.4665 54.25 77.5 54.25C76.5335 54.25 75.75 55.0335 75.75 56C75.75 56.9665 76.5335 57.75 77.5 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M77.5 61.25C78.4665 61.25 79.25 60.4665 79.25 59.5C79.25 58.5335 78.4665 57.75 77.5 57.75C76.5335 57.75 75.75 58.5335 75.75 59.5C75.75 60.4665 76.5335 61.25 77.5 61.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M77.5 64.75C78.4665 64.75 79.25 63.9665 79.25 63C79.25 62.0335 78.4665 61.25 77.5 61.25C76.5335 61.25 75.75 62.0335 75.75 63C75.75 63.9665 76.5335 64.75 77.5 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M77.5 71.75C78.4665 71.75 79.25 70.9665 79.25 70C79.25 69.0335 78.4665 68.25 77.5 68.25C76.5335 68.25 75.75 69.0335 75.75 70C75.75 70.9665 76.5335 71.75 77.5 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M77.5 75.25C78.4665 75.25 79.25 74.4665 79.25 73.5C79.25 72.5335 78.4665 71.75 77.5 71.75C76.5335 71.75 75.75 72.5335 75.75 73.5C75.75 74.4665 76.5335 75.25 77.5 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M77.5 89.25C78.4665 89.25 79.25 88.4665 79.25 87.5C79.25 86.5335 78.4665 85.75 77.5 85.75C76.5335 85.75 75.75 86.5335 75.75 87.5C75.75 88.4665 76.5335 89.25 77.5 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M77.5 92.75C78.4665 92.75 79.25 91.9665 79.25 91C79.25 90.0335 78.4665 89.25 77.5 89.25C76.5335 89.25 75.75 90.0335 75.75 91C75.75 91.9665 76.5335 92.75 77.5 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M77.5 103.25C78.4665 103.25 79.25 102.466 79.25 101.5C79.25 100.534 78.4665 99.75 77.5 99.75C76.5335 99.75 75.75 100.534 75.75 101.5C75.75 102.466 76.5335 103.25 77.5 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M81 40.25C81.9665 40.25 82.75 39.4665 82.75 38.5C82.75 37.5335 81.9665 36.75 81 36.75C80.0335 36.75 79.25 37.5335 79.25 38.5C79.25 39.4665 80.0335 40.25 81 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M81 47.25C81.9665 47.25 82.75 46.4665 82.75 45.5C82.75 44.5335 81.9665 43.75 81 43.75C80.0335 43.75 79.25 44.5335 79.25 45.5C79.25 46.4665 80.0335 47.25 81 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M81 54.25C81.9665 54.25 82.75 53.4665 82.75 52.5C82.75 51.5335 81.9665 50.75 81 50.75C80.0335 50.75 79.25 51.5335 79.25 52.5C79.25 53.4665 80.0335 54.25 81 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M81 57.75C81.9665 57.75 82.75 56.9665 82.75 56C82.75 55.0335 81.9665 54.25 81 54.25C80.0335 54.25 79.25 55.0335 79.25 56C79.25 56.9665 80.0335 57.75 81 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M81 75.25C81.9665 75.25 82.75 74.4665 82.75 73.5C82.75 72.5335 81.9665 71.75 81 71.75C80.0335 71.75 79.25 72.5335 79.25 73.5C79.25 74.4665 80.0335 75.25 81 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M81 82.25C81.9665 82.25 82.75 81.4665 82.75 80.5C82.75 79.5335 81.9665 78.75 81 78.75C80.0335 78.75 79.25 79.5335 79.25 80.5C79.25 81.4665 80.0335 82.25 81 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M81 89.25C81.9665 89.25 82.75 88.4665 82.75 87.5C82.75 86.5335 81.9665 85.75 81 85.75C80.0335 85.75 79.25 86.5335 79.25 87.5C79.25 88.4665 80.0335 89.25 81 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M81 92.75C81.9665 92.75 82.75 91.9665 82.75 91C82.75 90.0335 81.9665 89.25 81 89.25C80.0335 89.25 79.25 90.0335 79.25 91C79.25 91.9665 80.0335 92.75 81 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M81 96.25C81.9665 96.25 82.75 95.4665 82.75 94.5C82.75 93.5335 81.9665 92.75 81 92.75C80.0335 92.75 79.25 93.5335 79.25 94.5C79.25 95.4665 80.0335 96.25 81 96.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M81 99.75C81.9665 99.75 82.75 98.9665 82.75 98C82.75 97.0335 81.9665 96.25 81 96.25C80.0335 96.25 79.25 97.0335 79.25 98C79.25 98.9665 80.0335 99.75 81 99.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M81 103.25C81.9665 103.25 82.75 102.466 82.75 101.5C82.75 100.534 81.9665 99.75 81 99.75C80.0335 99.75 79.25 100.534 79.25 101.5C79.25 102.466 80.0335 103.25 81 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M84.5 40.25C85.4665 40.25 86.25 39.4665 86.25 38.5C86.25 37.5335 85.4665 36.75 84.5 36.75C83.5335 36.75 82.75 37.5335 82.75 38.5C82.75 39.4665 83.5335 40.25 84.5 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M84.5 43.75C85.4665 43.75 86.25 42.9665 86.25 42C86.25 41.0335 85.4665 40.25 84.5 40.25C83.5335 40.25 82.75 41.0335 82.75 42C82.75 42.9665 83.5335 43.75 84.5 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M84.5 47.25C85.4665 47.25 86.25 46.4665 86.25 45.5C86.25 44.5335 85.4665 43.75 84.5 43.75C83.5335 43.75 82.75 44.5335 82.75 45.5C82.75 46.4665 83.5335 47.25 84.5 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M84.5 64.75C85.4665 64.75 86.25 63.9665 86.25 63C86.25 62.0335 85.4665 61.25 84.5 61.25C83.5335 61.25 82.75 62.0335 82.75 63C82.75 63.9665 83.5335 64.75 84.5 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M84.5 71.75C85.4665 71.75 86.25 70.9665 86.25 70C86.25 69.0335 85.4665 68.25 84.5 68.25C83.5335 68.25 82.75 69.0335 82.75 70C82.75 70.9665 83.5335 71.75 84.5 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M84.5 75.25C85.4665 75.25 86.25 74.4665 86.25 73.5C86.25 72.5335 85.4665 71.75 84.5 71.75C83.5335 71.75 82.75 72.5335 82.75 73.5C82.75 74.4665 83.5335 75.25 84.5 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M84.5 89.25C85.4665 89.25 86.25 88.4665 86.25 87.5C86.25 86.5335 85.4665 85.75 84.5 85.75C83.5335 85.75 82.75 86.5335 82.75 87.5C82.75 88.4665 83.5335 89.25 84.5 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M84.5 92.75C85.4665 92.75 86.25 91.9665 86.25 91C86.25 90.0335 85.4665 89.25 84.5 89.25C83.5335 89.25 82.75 90.0335 82.75 91C82.75 91.9665 83.5335 92.75 84.5 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M84.5 103.25C85.4665 103.25 86.25 102.466 86.25 101.5C86.25 100.534 85.4665 99.75 84.5 99.75C83.5335 99.75 82.75 100.534 82.75 101.5C82.75 102.466 83.5335 103.25 84.5 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M88 40.25C88.9665 40.25 89.75 39.4665 89.75 38.5C89.75 37.5335 88.9665 36.75 88 36.75C87.0335 36.75 86.25 37.5335 86.25 38.5C86.25 39.4665 87.0335 40.25 88 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M88 47.25C88.9665 47.25 89.75 46.4665 89.75 45.5C89.75 44.5335 88.9665 43.75 88 43.75C87.0335 43.75 86.25 44.5335 86.25 45.5C86.25 46.4665 87.0335 47.25 88 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M88 57.75C88.9665 57.75 89.75 56.9665 89.75 56C89.75 55.0335 88.9665 54.25 88 54.25C87.0335 54.25 86.25 55.0335 86.25 56C86.25 56.9665 87.0335 57.75 88 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M88 64.75C88.9665 64.75 89.75 63.9665 89.75 63C89.75 62.0335 88.9665 61.25 88 61.25C87.0335 61.25 86.25 62.0335 86.25 63C86.25 63.9665 87.0335 64.75 88 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M88 71.75C88.9665 71.75 89.75 70.9665 89.75 70C89.75 69.0335 88.9665 68.25 88 68.25C87.0335 68.25 86.25 69.0335 86.25 70C86.25 70.9665 87.0335 71.75 88 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M88 75.25C88.9665 75.25 89.75 74.4665 89.75 73.5C89.75 72.5335 88.9665 71.75 88 71.75C87.0335 71.75 86.25 72.5335 86.25 73.5C86.25 74.4665 87.0335 75.25 88 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M88 78.75C88.9665 78.75 89.75 77.9665 89.75 77C89.75 76.0335 88.9665 75.25 88 75.25C87.0335 75.25 86.25 76.0335 86.25 77C86.25 77.9665 87.0335 78.75 88 78.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M88 82.25C88.9665 82.25 89.75 81.4665 89.75 80.5C89.75 79.5335 88.9665 78.75 88 78.75C87.0335 78.75 86.25 79.5335 86.25 80.5C86.25 81.4665 87.0335 82.25 88 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M88 85.75C88.9665 85.75 89.75 84.9665 89.75 84C89.75 83.0335 88.9665 82.25 88 82.25C87.0335 82.25 86.25 83.0335 86.25 84C86.25 84.9665 87.0335 85.75 88 85.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M88 89.25C88.9665 89.25 89.75 88.4665 89.75 87.5C89.75 86.5335 88.9665 85.75 88 85.75C87.0335 85.75 86.25 86.5335 86.25 87.5C86.25 88.4665 87.0335 89.25 88 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M88 99.75C88.9665 99.75 89.75 98.9665 89.75 98C89.75 97.0335 88.9665 96.25 88 96.25C87.0335 96.25 86.25 97.0335 86.25 98C86.25 98.9665 87.0335 99.75 88 99.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M88 103.25C88.9665 103.25 89.75 102.466 89.75 101.5C89.75 100.534 88.9665 99.75 88 99.75C87.0335 99.75 86.25 100.534 86.25 101.5C86.25 102.466 87.0335 103.25 88 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M91.5 36.75C92.4665 36.75 93.25 35.9665 93.25 35C93.25 34.0335 92.4665 33.25 91.5 33.25C90.5335 33.25 89.75 34.0335 89.75 35C89.75 35.9665 90.5335 36.75 91.5 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M91.5 40.25C92.4665 40.25 93.25 39.4665 93.25 38.5C93.25 37.5335 92.4665 36.75 91.5 36.75C90.5335 36.75 89.75 37.5335 89.75 38.5C89.75 39.4665 90.5335 40.25 91.5 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M91.5 43.75C92.4665 43.75 93.25 42.9665 93.25 42C93.25 41.0335 92.4665 40.25 91.5 40.25C90.5335 40.25 89.75 41.0335 89.75 42C89.75 42.9665 90.5335 43.75 91.5 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M91.5 50.75C92.4665 50.75 93.25 49.9665 93.25 49C93.25 48.0335 92.4665 47.25 91.5 47.25C90.5335 47.25 89.75 48.0335 89.75 49C89.75 49.9665 90.5335 50.75 91.5 50.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M91.5 64.75C92.4665 64.75 93.25 63.9665 93.25 63C93.25 62.0335 92.4665 61.25 91.5 61.25C90.5335 61.25 89.75 62.0335 89.75 63C89.75 63.9665 90.5335 64.75 91.5 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M91.5 71.75C92.4665 71.75 93.25 70.9665 93.25 70C93.25 69.0335 92.4665 68.25 91.5 68.25C90.5335 68.25 89.75 69.0335 89.75 70C89.75 70.9665 90.5335 71.75 91.5 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M91.5 75.25C92.4665 75.25 93.25 74.4665 93.25 73.5C93.25 72.5335 92.4665 71.75 91.5 71.75C90.5335 71.75 89.75 72.5335 89.75 73.5C89.75 74.4665 90.5335 75.25 91.5 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M91.5 85.75C92.4665 85.75 93.25 84.9665 93.25 84C93.25 83.0335 92.4665 82.25 91.5 82.25C90.5335 82.25 89.75 83.0335 89.75 84C89.75 84.9665 90.5335 85.75 91.5 85.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M91.5 89.25C92.4665 89.25 93.25 88.4665 93.25 87.5C93.25 86.5335 92.4665 85.75 91.5 85.75C90.5335 85.75 89.75 86.5335 89.75 87.5C89.75 88.4665 90.5335 89.25 91.5 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M91.5 92.75C92.4665 92.75 93.25 91.9665 93.25 91C93.25 90.0335 92.4665 89.25 91.5 89.25C90.5335 89.25 89.75 90.0335 89.75 91C89.75 91.9665 90.5335 92.75 91.5 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M91.5 96.25C92.4665 96.25 93.25 95.4665 93.25 94.5C93.25 93.5335 92.4665 92.75 91.5 92.75C90.5335 92.75 89.75 93.5335 89.75 94.5C89.75 95.4665 90.5335 96.25 91.5 96.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M91.5 99.75C92.4665 99.75 93.25 98.9665 93.25 98C93.25 97.0335 92.4665 96.25 91.5 96.25C90.5335 96.25 89.75 97.0335 89.75 98C89.75 98.9665 90.5335 99.75 91.5 99.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M95 33.25C95.9665 33.25 96.75 32.4665 96.75 31.5C96.75 30.5335 95.9665 29.75 95 29.75C94.0335 29.75 93.25 30.5335 93.25 31.5C93.25 32.4665 94.0335 33.25 95 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M95 36.75C95.9665 36.75 96.75 35.9665 96.75 35C96.75 34.0335 95.9665 33.25 95 33.25C94.0335 33.25 93.25 34.0335 93.25 35C93.25 35.9665 94.0335 36.75 95 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M95 47.25C95.9665 47.25 96.75 46.4665 96.75 45.5C96.75 44.5335 95.9665 43.75 95 43.75C94.0335 43.75 93.25 44.5335 93.25 45.5C93.25 46.4665 94.0335 47.25 95 47.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M95 54.25C95.9665 54.25 96.75 53.4665 96.75 52.5C96.75 51.5335 95.9665 50.75 95 50.75C94.0335 50.75 93.25 51.5335 93.25 52.5C93.25 53.4665 94.0335 54.25 95 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M95 57.75C95.9665 57.75 96.75 56.9665 96.75 56C96.75 55.0335 95.9665 54.25 95 54.25C94.0335 54.25 93.25 55.0335 93.25 56C93.25 56.9665 94.0335 57.75 95 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M95 64.75C95.9665 64.75 96.75 63.9665 96.75 63C96.75 62.0335 95.9665 61.25 95 61.25C94.0335 61.25 93.25 62.0335 93.25 63C93.25 63.9665 94.0335 64.75 95 64.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M95 78.75C95.9665 78.75 96.75 77.9665 96.75 77C96.75 76.0335 95.9665 75.25 95 75.25C94.0335 75.25 93.25 76.0335 93.25 77C93.25 77.9665 94.0335 78.75 95 78.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M95 89.25C95.9665 89.25 96.75 88.4665 96.75 87.5C96.75 86.5335 95.9665 85.75 95 85.75C94.0335 85.75 93.25 86.5335 93.25 87.5C93.25 88.4665 94.0335 89.25 95 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M95 96.25C95.9665 96.25 96.75 95.4665 96.75 94.5C96.75 93.5335 95.9665 92.75 95 92.75C94.0335 92.75 93.25 93.5335 93.25 94.5C93.25 95.4665 94.0335 96.25 95 96.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M95 99.75C95.9665 99.75 96.75 98.9665 96.75 98C96.75 97.0335 95.9665 96.25 95 96.25C94.0335 96.25 93.25 97.0335 93.25 98C93.25 98.9665 94.0335 99.75 95 99.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M95 103.25C95.9665 103.25 96.75 102.466 96.75 101.5C96.75 100.534 95.9665 99.75 95 99.75C94.0335 99.75 93.25 100.534 93.25 101.5C93.25 102.466 94.0335 103.25 95 103.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M98.5 33.25C99.4665 33.25 100.25 32.4665 100.25 31.5C100.25 30.5335 99.4665 29.75 98.5 29.75C97.5335 29.75 96.75 30.5335 96.75 31.5C96.75 32.4665 97.5335 33.25 98.5 33.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M98.5 36.75C99.4665 36.75 100.25 35.9665 100.25 35C100.25 34.0335 99.4665 33.25 98.5 33.25C97.5335 33.25 96.75 34.0335 96.75 35C96.75 35.9665 97.5335 36.75 98.5 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M98.5 40.25C99.4665 40.25 100.25 39.4665 100.25 38.5C100.25 37.5335 99.4665 36.75 98.5 36.75C97.5335 36.75 96.75 37.5335 96.75 38.5C96.75 39.4665 97.5335 40.25 98.5 40.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M98.5 54.25C99.4665 54.25 100.25 53.4665 100.25 52.5C100.25 51.5335 99.4665 50.75 98.5 50.75C97.5335 50.75 96.75 51.5335 96.75 52.5C96.75 53.4665 97.5335 54.25 98.5 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M98.5 68.25C99.4665 68.25 100.25 67.4665 100.25 66.5C100.25 65.5335 99.4665 64.75 98.5 64.75C97.5335 64.75 96.75 65.5335 96.75 66.5C96.75 67.4665 97.5335 68.25 98.5 68.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M98.5 71.75C99.4665 71.75 100.25 70.9665 100.25 70C100.25 69.0335 99.4665 68.25 98.5 68.25C97.5335 68.25 96.75 69.0335 96.75 70C96.75 70.9665 97.5335 71.75 98.5 71.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M98.5 82.25C99.4665 82.25 100.25 81.4665 100.25 80.5C100.25 79.5335 99.4665 78.75 98.5 78.75C97.5335 78.75 96.75 79.5335 96.75 80.5C96.75 81.4665 97.5335 82.25 98.5 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M102 36.75C102.966 36.75 103.75 35.9665 103.75 35C103.75 34.0335 102.966 33.25 102 33.25C101.034 33.25 100.25 34.0335 100.25 35C100.25 35.9665 101.034 36.75 102 36.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M102 43.75C102.966 43.75 103.75 42.9665 103.75 42C103.75 41.0335 102.966 40.25 102 40.25C101.034 40.25 100.25 41.0335 100.25 42C100.25 42.9665 101.034 43.75 102 43.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M102 50.75C102.966 50.75 103.75 49.9665 103.75 49C103.75 48.0335 102.966 47.25 102 47.25C101.034 47.25 100.25 48.0335 100.25 49C100.25 49.9665 101.034 50.75 102 50.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M102 54.25C102.966 54.25 103.75 53.4665 103.75 52.5C103.75 51.5335 102.966 50.75 102 50.75C101.034 50.75 100.25 51.5335 100.25 52.5C100.25 53.4665 101.034 54.25 102 54.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M102 57.75C102.966 57.75 103.75 56.9665 103.75 56C103.75 55.0335 102.966 54.25 102 54.25C101.034 54.25 100.25 55.0335 100.25 56C100.25 56.9665 101.034 57.75 102 57.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M102 75.25C102.966 75.25 103.75 74.4665 103.75 73.5C103.75 72.5335 102.966 71.75 102 71.75C101.034 71.75 100.25 72.5335 100.25 73.5C100.25 74.4665 101.034 75.25 102 75.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M102 78.75C102.966 78.75 103.75 77.9665 103.75 77C103.75 76.0335 102.966 75.25 102 75.25C101.034 75.25 100.25 76.0335 100.25 77C100.25 77.9665 101.034 78.75 102 78.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M102 82.25C102.966 82.25 103.75 81.4665 103.75 80.5C103.75 79.5335 102.966 78.75 102 78.75C101.034 78.75 100.25 79.5335 100.25 80.5C100.25 81.4665 101.034 82.25 102 82.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M102 85.75C102.966 85.75 103.75 84.9665 103.75 84C103.75 83.0335 102.966 82.25 102 82.25C101.034 82.25 100.25 83.0335 100.25 84C100.25 84.9665 101.034 85.75 102 85.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M102 89.25C102.966 89.25 103.75 88.4665 103.75 87.5C103.75 86.5335 102.966 85.75 102 85.75C101.034 85.75 100.25 86.5335 100.25 87.5C100.25 88.4665 101.034 89.25 102 89.25Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M102 92.75C102.966 92.75 103.75 91.9665 103.75 91C103.75 90.0335 102.966 89.25 102 89.25C101.034 89.25 100.25 90.0335 100.25 91C100.25 91.9665 101.034 92.75 102 92.75Z",
    fill: "#FF2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M102 103.25C102.966 103.25 103.75 102.466 103.75 101.5C103.75 100.534 102.966 99.75 102 99.75C101.034 99.75 100.25 100.534 100.25 101.5C100.25 102.466 101.034 103.25 102 103.25Z",
    fill: "#FF2842"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M14.5001 1.75C11.2527 1.75464 8.14003 3.04851 5.84624 5.34722C3.55246 7.64592 2.26526 10.7614 2.26758 14.0087C2.2699 17.2561 3.56155 20.3697 5.85861 22.6651C8.15568 24.9606 11.2702 26.25 14.5176 26.25C17.765 26.25 20.8795 24.9606 23.1765 22.6651C25.4736 20.3697 26.7653 17.2561 26.7676 14.0087C26.7699 10.7614 25.4827 7.64592 23.1889 5.34722C20.8951 3.04851 17.7825 1.75464 14.5351 1.75H14.5001ZM14.5001 5.25C16.8192 5.25464 19.0416 6.17976 20.679 7.82209C22.3164 9.46441 23.2349 11.6896 23.2326 14.0087C23.2303 16.3279 22.3074 18.5512 20.6667 20.1903C19.026 21.8293 16.8017 22.75 14.4826 22.75C12.1635 22.75 9.93918 21.8293 8.29849 20.1903C6.6578 18.5512 5.7349 16.3279 5.73258 14.0087C5.73026 11.6896 6.64871 9.46441 8.28612 7.82209C9.92353 6.17976 12.146 5.25464 14.4651 5.25H14.5001Z",
    fill: "#FF2842"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M14.5 19.25C17.3995 19.25 19.75 16.8995 19.75 14C19.75 11.1005 17.3995 8.75 14.5 8.75C11.6005 8.75 9.25 11.1005 9.25 14C9.25 16.8995 11.6005 19.25 14.5 19.25Z",
    fill: "#FF2842"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M103.75 14.0001C103.745 10.7527 102.451 7.64003 100.153 5.34625C97.8541 3.05246 94.7386 1.76526 91.4913 1.76758C88.2439 1.7699 85.1303 3.06155 82.8349 5.35862C80.5394 7.65568 79.25 10.7702 79.25 14.0176C79.25 17.265 80.5394 20.3795 82.8349 22.6765C85.1303 24.9736 88.2439 26.2653 91.4913 26.2676C94.7386 26.2699 97.8541 24.9827 100.153 22.6889C102.451 20.3951 103.745 17.2825 103.75 14.0351V14.0001ZM100.25 14.0001C100.245 16.3192 99.3202 18.5416 97.6779 20.179C96.0356 21.8165 93.8104 22.7349 91.4913 22.7326C89.1721 22.7303 86.9488 21.8074 85.3097 20.1667C83.6707 18.526 82.75 16.3017 82.75 13.9826C82.75 11.6635 83.6707 9.43918 85.3097 7.79849C86.9488 6.1578 89.1721 5.2349 91.4913 5.23258C93.8104 5.23027 96.0356 6.14871 97.6779 7.78612C99.3202 9.42353 100.245 11.646 100.25 13.9651V14.0001Z",
    fill: "#FF2842"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M86.25 14C86.25 16.8995 88.6005 19.25 91.5 19.25C94.3995 19.25 96.75 16.8995 96.75 14C96.75 11.1005 94.3995 8.75 91.5 8.75C88.6005 8.75 86.25 11.1005 86.25 14Z",
    fill: "#FF2842"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M2.25 90.9999C2.25464 94.2473 3.54851 97.36 5.84721 99.6538C8.14592 101.948 11.2614 103.235 14.5087 103.232C17.7561 103.23 20.8697 101.938 23.1651 99.6414C25.4606 97.3443 26.75 94.2298 26.75 90.9824C26.75 87.735 25.4606 84.6205 23.1651 82.3235C20.8697 80.0264 17.7561 78.7347 14.5087 78.7324C11.2614 78.7301 8.14592 80.0173 5.84721 82.3111C3.54851 84.6049 2.25464 87.7175 2.25 90.9649V90.9999ZM5.75 90.9999C5.75464 88.6808 6.67976 86.4584 8.32209 84.821C9.96441 83.1836 12.1896 82.2651 14.5087 82.2674C16.8279 82.2697 19.0512 83.1926 20.6903 84.8333C22.3293 86.474 23.25 88.6983 23.25 91.0174C23.25 93.3365 22.3293 95.5608 20.6903 97.2015C19.0512 98.8422 16.8279 99.7651 14.5087 99.7674C12.1896 99.7697 9.96441 98.8513 8.32209 97.2139C6.67976 95.5765 5.75464 93.354 5.75 91.0349V90.9999Z",
    fill: "#FF2842"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M19.75 92.1055C19.75 89.206 17.3995 86.8555 14.5 86.8555C11.6005 86.8555 9.25 89.206 9.25 92.1055C9.25 95.005 11.6005 97.3555 14.5 97.3555C17.3995 97.3555 19.75 95.005 19.75 92.1055Z",
    fill: "#FF2842"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRednoteQrcode);
export default __webpack_public_path__ + "static/media/rednote_qrcode.72f8c41cd1f3e6d40fe90d353b09e1dd.svg";
export { ForwardRef as ReactComponent };